<template>
    <Bulletins :Mode="false" Type="3"></Bulletins>
</template>

<script>
import Vue from 'vue';
import Bulletins from '@/components/DPEBB/Administrator/Bulletins.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID :3,
        }
    },
    components: {

        Bulletins,

    },
    created: function() {
        this.AppServiceID = this.$store.getters.GetOpticalID;
        this.$emit('update:layout', LayoutDefault);
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID);
    },
}
</script>

<style>

</style>
